// TermsOfService.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import { sanitize } from 'isomorphic-dompurify';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { NULL_FUNCTION } from '../resource/defaults.js';

import BackIcon from '../../img/ic_topbar_back.svg';

export class TermsOfService extends React.PureComponent {
  render() {
    const { t, goBack } = this.props;
    const string = t('tos_description', {
      ns: TranslationNamespace.SETTINGS,
    });
    const html = sanitize(string);

    return (
      <StyledTermsOfService>
        <Header>
          <CloseButton role="button" onClick={goBack}>
            <CloseIcon src={BackIcon} title="close" />
          </CloseButton>
          <HeaderTitle>
            {t('seo_tos_h1', {
              ns: TranslationNamespace.SEO,
            })}
          </HeaderTitle>
        </Header>
        <Body>
          <UpdateDate>
            {t('tos_updated', {
              ns: TranslationNamespace.SETTINGS,
            })}
          </UpdateDate>
          <TosDescription dangerouslySetInnerHTML={{ __html: html }} />
        </Body>
      </StyledTermsOfService>
    );
  }
}

TermsOfService.propTypes = {
  goBack: PropTypes.func,
  t: PropTypes.func.isRequired,
};

TermsOfService.defaultProps = {
  goBack: NULL_FUNCTION,
};

const StyledTermsOfService = styled.div`
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
  background-color: #191919;
  padding-top: var(--space-to-pinned-notification);
`;

const Header = styled.div`
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 32px;
  border-bottom: 1px solid rgb(100, 100, 100, 0.5);
  height: 58px;
  background-color: #232323;
`;

const CloseButton = styled.div`
  box-sizing: content-box;
  position: absolute;
  top: 0;
  left: 0;
  padding: 14px 16px;
  cursor: pointer;
  height: 30px;
  :hover {
    opacity: 0.7;
  }
`;

const UpdateDate = styled.div`
  height: 12px;
  font-size: 12px;
  line-height: 1;
  color: #646464;
  margin-bottom: 20px;
`;

const CloseIcon = styled.img`
  height: 100%;
  width: auto;
  vertical-align: top;
`;

const HeaderTitle = styled.h1`
  flex: none;
  margin: 0px;
  font-size: 16px;
  color: #ffffff;
`;

const Body = styled.div`
  border-bottom: 1px solid rgb(100, 100, 100, 0.5);
  border-top: 1px solid rgb(100, 100, 100, 0.5);
  padding: 20px 16px;
  background-color: #232323;
  overflow: auto;
`;

const TosDescription = styled.div`
  font-size: 14px;
  text-align: justify;
  line-height: 1.43;
`;

export default withTranslation()(TermsOfService);
